import React from "react";
import { Edit3, Trash2 } from "lucide-react";

const FAQList = ({ faqs = [], onEdit, onDelete }) => {
  return (
    <div>
      <h2 className="text-2xl font-semibold text-gray-800 mb-6">
        Frequently Asked Questions
      </h2>

      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-200 bg-white rounded-xl shadow-sm">
          <thead>
            <tr className="bg-green-600 text-white">
              <th className="px-6 py-3 text-left font-semibold w-16">#</th>
              <th className="px-6 py-3 text-left font-semibold">Question</th>
              <th className="px-6 py-3 text-left font-semibold">Answer</th>
              <th className="px-6 py-3 text-center font-semibold w-32">
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {faqs.length === 0 ? (
              <tr>
                <td
                  colSpan={4}
                  className="px-6 py-4 text-center text-gray-400 text-sm"
                >
                  No FAQs added yet.
                </td>
              </tr>
            ) : (
              faqs.map((faq, index) => {
                const id = faq.faq_id ?? faq.id;
                return (
                  <tr
                    key={id}
                    className="border-t hover:bg-gray-50 transition text-sm"
                  >
                    <td className="px-6 py-3 text-gray-700 font-medium">
                      {typeof faq.sort_order === "number"
                        ? faq.sort_order
                        : index + 1}
                    </td>
                    <td className="px-6 py-3 font-medium text-gray-800">
                      {faq.question}
                    </td>
                    <td className="px-6 py-3 text-gray-600 max-w-md truncate">
                      {faq.answer}
                    </td>
                    <td className="px-6 py-3 text-center">
                      <button
                        onClick={() => onEdit && onEdit(faq)}
                        className="text-blue-600 hover:text-blue-800 transition"
                        title="Edit"
                      >
                        <Edit3 size={18} />
                      </button>
                      <button
                        onClick={() => onDelete && onDelete(id)}
                        className="ml-3 text-red-600 hover:text-red-800 transition"
                        title="Delete"
                      >
                        <Trash2 size={18} />
                      </button>
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default FAQList;
